import { useScroll, useTransform, motion } from "framer-motion";
import { useRef } from "react";

const LegoStack = () => {
  const containerRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ["start end", "end start"],
  });

  const legoImages = [
    "https://res.cloudinary.com/dhifyp04n/image/upload/v1744404404/Group_402_vtcxlh.png",
    "https://res.cloudinary.com/dhifyp04n/image/upload/v1744404411/Group_403_fcrsuv.png",
    "https://res.cloudinary.com/dhifyp04n/image/upload/v1744404385/Group_404_jwyize.png",
    "https://res.cloudinary.com/dhifyp04n/image/upload/v1744404378/Group_405_w1yehv.png",
    "https://res.cloudinary.com/dhifyp04n/image/upload/v1744404370/Group_406_tst8tg.png",
    "https://res.cloudinary.com/dhifyp04n/image/upload/v1744404363/Group_410_fqxfjm.png",
    "https://res.cloudinary.com/dhifyp04n/image/upload/v1744404345/lego_7_yhmhsz.png",
    "https://res.cloudinary.com/dhifyp04n/image/upload/v1744404353/lego_8_slbrcv.png"
  ];

  const yTransforms = [
    useTransform(scrollYProgress, [0.00, 0.07], [100, 0]),
    useTransform(scrollYProgress, [0.07, 0.14], [100, 0]),
    useTransform(scrollYProgress, [0.14, 0.21], [100, 0]),
    useTransform(scrollYProgress, [0.21, 0.28], [100, 0]),
    useTransform(scrollYProgress, [0.28, 0.35], [100, 0]),
    useTransform(scrollYProgress, [0.35, 0.42], [100, 0]),
    useTransform(scrollYProgress, [0.42, 0.49], [100, 0]),
    useTransform(scrollYProgress, [0.49, 0.56], [100, 0]),
  ];

  const legoStyle = {
    width: "140px",
    height: "auto",
    display: "block",
    margin: "0 auto",
    position: "relative",
    marginTop: -20,
  };

  return (
      <div
        ref={containerRef}
        style={{
          height: "1000px",
          padding: "100px 0",
          position: "relative",
        }}
      >
        {legoImages.map((src, index) => (
          <motion.img
            key={index}
            src={src}
            alt={`LEGO piece ${index + 1}`}
            style={{
              ...legoStyle,
              zIndex: legoImages.length - index,
              y: yTransforms[index],
            }}
          />
        ))}
      </div>
  );
};

export default LegoStack;